import { combineReducers } from "redux";
import { dynamicInvoicesPageReducer } from "./dynamic-invoice-page/reducer";
export const dynamicInvoicesPagesReducer = combineReducers({
    dynamicInvoicesPage: dynamicInvoicesPageReducer
});
